import { render, staticRenderFns } from "./layout-tablet.vue?vue&type=template&id=38cb4a35&scoped=true&"
import script from "./layout-tablet.js?vue&type=script&lang=js&"
export * from "./layout-tablet.js?vue&type=script&lang=js&"
import style0 from "./layout-tablet.scss?vue&type=style&index=0&id=38cb4a35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb4a35",
  null
  
)

export default component.exports